<div class="setup-portal-menu" data-cy='setup-portal-menu'>
    <nav role="navigation" class="wb-menu" [class.selected]="setupPortalMenuIsOpen" (click)="toggleSetupPortalMenu()" aria-haspopup="true">
      <span class="glyphicon glyphicon-cog mrgn-rght-sm"></span>
      <span class="underline" data-cy="setup-my-portal">{{'application_features.setupMyPortal.title' | translate}}</span>
    </nav>
    <span class="split">|</span>
</div>
<div [ngClass]="{ 'menu-setup-portal-open': setupPortalMenuIsOpen, 'outer-menu-div': !setupPortalMenuIsOpen, 'french': isLangFrench }">
    <ul
        role="menu"
        aria-orientation="vertical"
        class="wb-init wb-data-ajax-replace-inited setup-portal-menu-ul"
        id="wb-auto-0"
        data-ajax-replace=""
    >
        <li
            *ngFor="let item of setupMenuItems | applyAcl | async"
            role="presentation">
            <a
                role="menuitem"
                tabindex="0"
                aria-haspopup="true"
                aria-controls="gc-mnu-jobs"
                aria-expanded="false"
                class="menu-link"
                attr.data-cy="{{item.dataCy}}"
                [class.border-top]="item.topDivider"
                [class.border-bottom]="item.bottomDivider"
                [carmRouterLink]="item.path"
                >{{ item.localizationKey + '.title' | translate }}</a>
        </li>
    </ul>
</div>
